
























































import Vue from 'vue'
export default Vue.extend({

  props: {
    buttonText: {
      type: String,
      default: ''
    },
    buttonClasses: {
      type: String,
      default: 'btn btn-details btn-outline btn-info'
    },
    modalSize: {
      type: String,
      default: 'modal-sm'
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    containerClasses: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      show: false,
      moving: false,
      startingX: 0,
      startingY: 0,
      modalTopOffset: 0,
      modalLeftOffset: 0
    }
  },

  methods: {

    drag(e: MouseEvent) {
      this.startingX = e.screenX - this.modalLeftOffset
      this.startingY = e.screenY - this.modalTopOffset
      this.moving = true
    },

    stopDrag() {
      this.moving = false
    },

    move(e: MouseEvent) {
      if (this.moving) {
        this.modalTopOffset = e.screenY - this.startingY
        this.modalLeftOffset = e.screenX - this.startingX
      }
    },

    showModal() {
      this.$emit('onModalShow')
      this.$emit('modal-show')
      this.show = true
    },
    
    hideModal() {
      this.$emit('onModalHide')
      this.$emit('modal-hide')
      this.show = false
    }
  },

  created() {
    this.$parent.$on('dismissModals', () => this.show = false)
  }

})
